import { registerPlugin } from '@capacitor/core';

interface PrinterTerminal {
  print: (data: {imageUrl: string}) => any;
}

const PrinterTerminal = registerPlugin<PrinterTerminal>('PrinterTerminal');

export default PrinterTerminal;
